import React from 'react';
import { colorConstants } from 'config/colorConstants';

const LogOut = ({
    stroke = colorConstants.white,
    width = 14,
    height = 14,
}: {
    stroke?: string;
    width?: number;
    height?: number;
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 17l5-5m0 0-5-5m5 5H9M9 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H9"
                stroke={stroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LogOut;
